/*
 * @Author: Zhouqi
 * @Date: 2025-10-31 18:11:59
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-30 15:22:08
 */
import { QueryType, TaskType } from '@/components/DrawerTaskPanel/service';

import { F_CLOUD_TASK_TYPE } from './const';
import { t } from './helper/intl';
import {
  aiRemovalURL,
  aiVideoEditURL,
  avatarVideoProURL,
  faceSwapperURL,
  imageEnhanceURL,
  imageGenerateURL,
  imageTranslationURL,
  productAvatarURL,
  videoGenerateURL,
  videoTranslateURL,
  voiceCloneURL,
} from './routeConstants';

export * from './routeConstants';

// 页面路由和任务类型映射配置
export const FeatureConfig = {
  VIDEO_GENERATE: {
    url: videoGenerateURL,
    name: t('9a1641a16a4cc4df9ffa2a17b6348ae0'),
    queryTypes: [
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_VIDEO_GENERATE,
        taskType: TaskType.BATCH,
      },
    ],
  },
  IMAGE_GENERATE: {
    url: imageGenerateURL,
    name: t('c7741980e9f14c014b9e2182050da31e-2'),
    queryTypes: [
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_IMAGE_GENERATE,
        taskType: TaskType.BATCH,
      },
    ],
  },
  VIDEO_TRANSLATE: {
    url: videoTranslateURL,
    name: t('merror.translation.title'),
    queryTypes: [
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_BATCH_SUBTITLE_TRANS,
        taskType: TaskType.BATCH,
      },
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_BATCH_AUDIO_TRANS,
        taskType: TaskType.BATCH,
      },
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_BATCH_SUBTITLE_AUDIO_TRANS,
        taskType: TaskType.BATCH,
      },
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_MULTI_SUBTITLE_TRANS,
        taskType: TaskType.BATCH,
      },
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_MULTI_SUBTITLE_AUDIO_TRANS,
        taskType: TaskType.BATCH,
      },
    ],
  },
  AVATAR_VIDEO: {
    url: avatarVideoProURL,
    name: t('bc.AvatarVideoPro'),
    queryTypes: [
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_AVATAR_VIDEO_2_0,
        taskType: 2,
      },
    ],
  },
  PRODUCT_AVATAR: {
    url: productAvatarURL,
    name: t('Product-avatar-video'),
    queryTypes: [
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_PRODUCT_AVATAR,
        taskType: TaskType.BATCH,
      },
    ],
  },
  FACE_SWAPPER: {
    url: faceSwapperURL,
    name: t('2-0'),
    queryTypes: [
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_FACE_SWAP,
        taskType: TaskType.BATCH,
      },
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_HEAD_SWAP,
        // taskType: TaskType.PARENT,
        taskType: TaskType.BATCH,
      },
    ],
  },
  VOICE_CLONE: {
    url: voiceCloneURL,
    name: t('ce24a821ce9a84f071a4b291570d64b6'),
    queryTypes: [
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_TEXT_TO_SPEECH,
        taskType: TaskType.BATCH,
      },
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_VOICE_CLONE,
        taskType: TaskType.BATCH,
      },
    ],
  },
  IMAGE_ENHANCE: {
    url: imageEnhanceURL,
    name: t('bc.ImageEnhance'),
    queryTypes: [
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_IMAGE_ENHANCE,
        taskType: TaskType.BATCH,
      },
    ],
  },
  IMAGE_TRANSLATE: {
    url: imageTranslationURL,
    name: t('bc.ImageTranslation'),
    queryTypes: [
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_IMAGE_TRANSLATE,
        taskType: TaskType.BATCH,
      },
    ],
  },
  VIDEO_REMOVAL: {
    url: aiRemovalURL,
    name: t('bc.removal'),
    queryTypes: [
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_VIDEO_REMOVAL,
        taskType: TaskType.BATCH,
      },
    ],
  },
  VIDEO_EDIT: {
    url: aiVideoEditURL,
    name: t('9613af8a82f375ffce54844fc0a470cc'),
    queryTypes: [
      {
        cloudTaskType: F_CLOUD_TASK_TYPE.F_VIDEO_EDIT,
        taskType: TaskType.BATCH,
      },
    ],
  },
};

export const getFeatureTypes = (url: string): QueryType[] => {
  const feature = Object.values(FeatureConfig).find((item) => item.url === url);
  return feature ? feature.queryTypes : [];
};
export const getFeatureName = (url: string): string => {
  const feature = Object.values(FeatureConfig).find((item) => item.url === url);
  return feature ? feature.name : '';
};
// tab 参数
export const VoiceCloneTabParam = {
  TEXT_TO_SPEECH: 'text-to-speech',
  VOICE_CLONE: 'voice-clone',
};
